import { useState, type InputHTMLAttributes } from 'react';
import { cn } from '@nexply/ui';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  hint?: string;
};

export function FloatingField({ id, label, value, onChange, hint, className, ...rest }: Props) {
  const [focused, setFocused] = useState(false);
  const float = focused || value.length > 0;
  return (
    <div className="relative">
      <input
        id={id}
        {...rest}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={cn(
          'peer h-14 w-full rounded-xl border border-line bg-surface-2 px-4 pt-5 pb-1.5 text-base text-text placeholder-transparent',
          'focus:outline-none focus:border-gold/40 focus:bg-surface-3 transition',
          className,
        )}
        placeholder={label}
      />
      <label
        htmlFor={id}
        className={cn(
          'pointer-events-none absolute left-4 transition-all duration-150',
          float ? 'top-1.5 text-[10px] uppercase tracking-wider text-gold/80' : 'top-1/2 -translate-y-1/2 text-base text-text-muted',
        )}
      >
        {label}
      </label>
      {hint && <div className="mt-1.5 text-[11px] text-text-muted px-1">{hint}</div>}
    </div>
  );
}
